import { Action } from 'redux';
import { PlanAttributes, SummaryView } from '../../plan-selection/interfaces/plan-attributes.interface';
import { Product } from '../../plan-selection/interfaces/product.interface';
import { OnExchangeEnrollDataTemplate } from '../interfaces/on-exchange.enroll-data.interface';
export interface OnExchangeEnrollManagerStateStructure {
  application: OnExchangeEnrollDataTemplate;
  selectedProduct: Product<PlanAttributes, SummaryView>;
}
const INITIAL_STATE: OnExchangeEnrollManagerStateStructure = {
  application: null,
  selectedProduct: null
};

const RESET_ENROLL_MANAGER_STATE = 'RESET_ENROLL_MANAGER_STATE';
const SET_APPLICATION = 'SET_APPLICATION';
const SET_PRODUCT = 'SET_PRODUCT';

export class OnExchangeEnrollManagerAction implements Action {
  type: string;
  application?: OnExchangeEnrollDataTemplate;
  selectedProduct?: Product<PlanAttributes, SummaryView>;
}

export function setApplication(application: OnExchangeEnrollDataTemplate): OnExchangeEnrollManagerAction {
  return { type: SET_APPLICATION, application };
}
export function resetState(): OnExchangeEnrollManagerAction {
  return { type: RESET_ENROLL_MANAGER_STATE };
}
export function setProduct(selectedProduct: Product<PlanAttributes, SummaryView>): OnExchangeEnrollManagerAction {
  return { type: SET_PRODUCT, selectedProduct };
}

export const ON_EXCHANGE_ENROLL_MANAGER_REDUCER_NAME = 'OnExchangeEnrollManager';
export function OnExchangeEnrollManager(
  state: OnExchangeEnrollManagerStateStructure = INITIAL_STATE,
  action: OnExchangeEnrollManagerAction
) {
  const copiedState: OnExchangeEnrollManagerStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {

    case SET_PRODUCT:

      copiedState.selectedProduct = action.selectedProduct;
      return Object.assign({}, state, copiedState);

    case SET_APPLICATION:

      copiedState.application = action.application;
      return Object.assign({}, state, copiedState);

    case RESET_ENROLL_MANAGER_STATE:
      return Object.assign({}, state, INITIAL_STATE);

    default:
      return state;
  }
}
